// components/NavBar/Navigation.jsx

import React, { useContext, useEffect } from "react";
import { motion } from "framer-motion";
import { MenuItem } from "./MenuItem";
import ScreenContext from "../../context/ScreenContext";

const variants = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.2 },
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1 },
  },
};

export default function Navigation({ items, isOpen, toggle }) {
  const handleToggle = () => {
    toggle();
  };

  const s = useContext(ScreenContext);
  const mobile = s.mobile;

  // cannot scroll 
  useEffect(() => {
    if (isOpen) {
      // Disable scroll
      document.body.style.overflow = "hidden";
    } else {
      // Re-enable scroll
      document.body.style.overflow = "";
    }

    // Clean up in case component unmounts
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <motion.ul
      initial="closed"
      animate={isOpen ? "open" : "idle"}
      className={`motion-ul ${mobile && isOpen ? "mobile" : isOpen ? "show" : ""
        }`}
      variants={variants}
      onClick={handleToggle}
    >
      <MenuItem items={items} />
    </motion.ul>
  );
}
